import { Wallet, Receipt, Landmark, TrendingUp, PiggyBank, Shield, Home, Coins, BarChart3, GraduationCap, Scale, Globe, CreditCard, HeartHandshake } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import Reveal from "./Reveal";
import beamy from "@/assets/beamy.png";

const TopicsSection = () => {
  const { t } = useLanguage();

  const topics = [
    { icon: Wallet, key: "topics.budget" },
    { icon: Receipt, key: "topics.taxes" },
    { icon: Landmark, key: "topics.pillar3a" },
    { icon: TrendingUp, key: "topics.etfs" },
    { icon: PiggyBank, key: "topics.saving" },
    { icon: Shield, key: "topics.insurance" },
    { icon: Home, key: "topics.realestate" },
    { icon: Coins, key: "topics.crypto" },
    { icon: BarChart3, key: "topics.investing" },
    { icon: GraduationCap, key: "topics.basics" },
    { icon: Scale, key: "topics.debt" },
    { icon: CreditCard, key: "topics.credit" },
    { icon: Globe, key: "topics.sustainability" },
    { icon: HeartHandshake, key: "topics.pension" },
  ];

  // leicht unregelmässige Streuung statt exaktem Raster
  const tilts = [-1.4, 0.9, -0.5, 1.6, -1.1, 0.4, 1.2, -0.8, 0.7, -1.5, 1.1, -0.3, 0.8, -1.2];
  const nudges = [0, 4, -3, 2, 5, -2, 3, -4, 1, 4, -3, 2, -1, 3];

  return (
    <section className="py-24 bg-ink-800">
      <div className="container mx-auto px-6">
        <Reveal className="text-center mb-12 max-w-2xl mx-auto">
          <div className="eyebrow mb-4">{t("eyebrow.topics")}</div>
          <h2 className="font-display text-4xl md:text-5xl text-white mb-4">{t("topics.title")}</h2>
          <p className="text-lg text-white/65">{t("topics.sub")}</p>
        </Reveal>

        <div className="flex flex-wrap justify-center gap-2.5 max-w-4xl mx-auto">
          {topics.map((topic, i) => (
            <Reveal key={i} delay={i * 35}>
              <div
                className="flex items-center gap-2 bg-ink-700 border border-white/[0.06] px-4 py-2.5 rounded-full hover:border-violet/40 hover:bg-violet/5 transition-all duration-200 hover:!rotate-0"
                style={{ transform: `rotate(${tilts[i]}deg) translateY(${nudges[i]}px)` }}
              >
                <topic.icon className={`h-4 w-4 ${i % 5 === 2 ? "text-coral" : "text-violet"}`} />
                <span className="text-sm font-medium text-white/85">{t(topic.key)}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200} className="mt-10 flex items-center justify-center gap-3">
          <img src={beamy} alt="" aria-hidden className="w-9 h-9 object-contain animate-float" />
          <span className="font-display italic text-white/70 text-lg">{t("beamy.note.topics")}</span>
        </Reveal>
      </div>
    </section>
  );
};

export default TopicsSection;
